import { useState } from 'react';
import { GetChangeRequestsByNPN } from '../../api/MyIMO';
import { useQuery } from '@tanstack/react-query';
import LoadingIndicator from '../../components/Global/loading-indicator/loading-indicator';
import NewChangeRequestModal from '../MyIMO/components/modal/NewChangeRequestModal';
import { Typography, Box, Stack, Button, Alert } from '@mui/material';
import ChangeRequestMyProfile from './components/datagrid/ChangeRequestMyProfile';

const ChangeRequests = ({ user }) => {
  const [showNewRequestModal, setShowNewRequestModal] = useState(false);
  const { producerID } = user;

  const getChangeRequestsByNPN = useQuery({
    queryKey: ['getChangeRequestsByNPN'],
    queryFn: () => GetChangeRequestsByNPN()(),
    refetchOnWindowFocus: true,
  });

  const toggleModal = () => {
    setShowNewRequestModal((prev) => !prev);
  };

  return (
    <Box sx={{ padding: '1rem' }}>
      {getChangeRequestsByNPN.isError && (
        <Box padding={'1rem 0'}>
          <Alert sx={{ width: 'fit-content' }} severity="warning">
            Something went wrong
          </Alert>
        </Box>
      )}
      <Stack
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        direction={{ xs: 'column', md: 'row' }}
      >
        <Typography component={'h3'} sx={{ padding: '1rem 0' }} variant="h6">
          Change Requests
        </Typography>
        <Stack
          direction="row"
          gap={2}
          width={{ xs: '100%', md: 'unset' }}
          justifyContent={{ xs: 'flex-end', md: 'unset' }}
          padding={{ xs: '.5rem 0', md: 'unset' }}
        >
          <Button
            onClick={toggleModal}
            sx={{ height: 'fit-content', padding: '.5rem .875rem' }}
            variant="contained"
          >
            New Request
          </Button>
        </Stack>
      </Stack>
      {getChangeRequestsByNPN.isPending ? (
        <LoadingIndicator />
      ) : (
        <ChangeRequestMyProfile
          isLoading={getChangeRequestsByNPN.isPending}
          data={getChangeRequestsByNPN.data}
        />
      )}
      <NewChangeRequestModal
        producerID={producerID}
        showModal={showNewRequestModal}
        toggleModal={toggleModal}
        refetchRequests={getChangeRequestsByNPN.refetch}
        IMOSubmission={false}
      />
    </Box>
  );
};

export default ChangeRequests;
